import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import ButtonScrollDown from 'components/ButtonScrollDown'
import { RU } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import AddAndGoToCart from 'containers/AddAndGoToCart'
import CostContainerSale from 'containers/CostContainerSale'
import { LocalizationContext } from 'contexts/Localization'
import { MenuMainContext } from 'contexts/MenuMain'
import { Text, H1Small as H1 } from 'styles/components/typography'

import DHowFirstEuroBox from './components/DHowFirstEuroBox'
import DHowFirstRussianBox from './components/DHowFirstRussianBox'
import { Article } from './styles'

/**
 * DHowFirst
 *
 * @param {object} props - properties of component
 * @returns {node} DHowFirst
 */
const DHowFirst = props => {
  const { data, secondBlockRef } = props
  const { locale, paths } = useContext(LocalizationContext)
  const { isSalesBanner, salesBannerHeight } = React.useContext(MenuMainContext)

  return (
    <FirstBlockWrapper
      isExtraTopIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
      className="bg--gray--op-06 pb-2 pb-md-4"
    >
      <div className="row" />

      <div className="row">
        <div className="col-12 col-md-6">
          <Article className="first-content-top-indent">
            <H1 dangerouslySetInnerHTML={{ __html: data.title }} />
            <Text dangerouslySetInnerHTML={{ __html: data.content }} />
          </Article>
          <div className="d-flex align-items-center pt-4">
            <AddAndGoToCart
              goods={[
                {
                  type: GOODS_TYPES.dna,
                  isSubscription: false,
                },
              ]}
              buttonProps={{
                bgClassName: 'bg--green',
                withTopMarginOnMobile: true,
              }}
              buttonTitleKey={'order_test'}
              forceMultipleAdd={true}
            />

            <CostContainerSale
              className="ml-15"
              productType={GOODS_TYPES.dna}
              isMobileCenter={true}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          {locale === RU ? (
            <DHowFirstRussianBox {...{ path: `${paths.cdn_global}/boxes` }} />
          ) : (
            <DHowFirstEuroBox {...{ path: `${paths.cdn_global}/boxes` }} />
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 pt-4">
          <ButtonScrollDown
            title={data.go_to_site}
            refToScroll={secondBlockRef}
          />
        </div>
      </div>
    </FirstBlockWrapper>
  )
}

DHowFirst.propTypes = {
  data: PropTypes.object.isRequired,
  secondBlockRef: PropTypes.object.isRequired,
}

DHowFirst.defaultProps = {}

export default DHowFirst
